import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { GlobalConfigProps, LanguageService } from '../../services';

export const RcmGlobalConfig = (props: GlobalConfigProps): JSX.Element => {
  useEffect(() => {
    document.documentElement.lang = props.locale || LanguageService.defaultLocale;
  });

  return (
    <Helmet>
      <meta name="global-config" content={JSON.stringify(props)} />
      <meta name="country-language" content={`${props.country}-${props.locale}`} />
    </Helmet>
  );
};
